import React from 'react';
import FormField from './FormField';

/**
 * @typedef IProps
 * @property {string} value
 * @property {React.Dispatch<string>} setValue
 *
 * @param {IProps} props
 */
function InputIdCard({ value, setValue }) {
  return (
    <FormField
      type="text"
      label="เลขที่ประจำตัว"
      placeholder="เลขที่พาสปอร์ต / เลขที่ Work Permit / เลขที่ CI No. / TD No. / เลขที่ใบแทนอนุญาตทำงาน (บต.23, 39, 48)"
      value={value}
      onChange={(e) => setValue(e.target.value)}
    />
  );
}

export default InputIdCard;
